/**
 * Resizes the Konva stage to the host element's client rectangle (CSS pixels).
 * Extracted for unit tests without a full Konva stack.
 */
export interface UppKonvaStageBoundsTarget {
  width(w: number): unknown;
  height(h: number): unknown;
  batchDraw(): void;
}

export function syncStageSizeToHost(stage: UppKonvaStageBoundsTarget, host: HTMLElement): void {
  stage.width(Math.max(1, host.clientWidth));
  stage.height(Math.max(1, host.clientHeight));
  stage.batchDraw();
}
